import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MaskLines } from "../site/Motion";

export const FinalCta = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} data-testid="home-final-cta" className="relative h-[80svh] min-h-[520px] overflow-hidden bg-[var(--ink)]">
      <motion.img style={{ y, scale: 1.3 }} src="/brand/bus.jpg" alt="Frente del ómnibus Santiagueño" className="absolute inset-0 h-full w-full object-cover object-[78%_50%]" />
      <div className="absolute inset-0 bg-[radial-gradient(80%_70%_at_75%_45%,transparent_10%,rgba(7,20,12,.92)_75%)]" />
      <div className="relative mx-auto flex h-full max-w-[1400px] flex-col justify-end px-5 pb-16 md:px-10 md:pb-24">
        <h2 className="font-display text-5xl text-white md:text-7xl lg:text-8xl"><MaskLines inView lines={["Más que", "un viaje."]} /></h2>
        <Link to="/pasajes" data-testid="final-cta-button" className="group mt-10 inline-flex items-center gap-3 self-start rounded-full bg-[var(--lime)] px-8 py-4 text-lg font-bold text-[var(--ink)] transition-transform duration-300 hover:-translate-y-1">
          Comprar pasajes <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:rotate-45" />
        </Link>
      </div>
    </section>
  );
};
